import React, { memo } from "react";

const AppClockIcon = ({ color = "#666666", className }) => {
	return (
		<svg className={className} width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="12" r="10" />
			<path d="M12 6v6l4 2" />
		</svg>
	);
};

export default memo(AppClockIcon);
